import { registerLocaleData } from '@angular/common';
import localeDe from '@angular/common/locales/de';
import localeEn from '@angular/common/locales/en';
import localeEs from '@angular/common/locales/es';
import localeEu from '@angular/common/locales/eu';
import localeFr from '@angular/common/locales/fr';
import localeIt from '@angular/common/locales/it';
import localeNo from '@angular/common/locales/no';
import localePt from '@angular/common/locales/pt';

export function registerAppLocaleData() {
	registerLocaleData(localeEs);
	registerLocaleData(localeEn);
	registerLocaleData(localePt);
	registerLocaleData(localeIt);
	registerLocaleData(localeFr);
	registerLocaleData(localeDe);
	registerLocaleData(localeEu);
	registerLocaleData(localeNo);
}
